import React, { useState, useEffect, Suspense } from "react";
import HttpsRedirect from "react-https-redirect";
import "./App.css";
import "./AppMedia.css";
import "./AdminDesign.css";
import "./modernIcons.css";
import Sidebar from "./components/sidebar/sidebar";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import AllImages from "./constant/img";
import RequireAuth from "./components/RequireAuth";
import LegacyAdminRedirect from "./components/LegacyAdminRedirect";
import ShippingDashboard from "./components/shippingDashboard/shippingDashboard";
const Admin = React.lazy(() => import("./pages/admin/admin"));
const Signup = React.lazy(() => import("./pages/signup/signup"));
const ForgetPassword = React.lazy(() => import("./pages/forgetPassword/forgetPassword"));
const ConfirmPassword = React.lazy(() => import("./pages/confirmPassword/confirmPassword"));
const UserAccount = React.lazy(() => import("./components/userAccount/userAccount"));
const SubscribedUser = React.lazy(() => import("./components/subscribedUser/subscribedUser"));
const ChangePassword = React.lazy(() => import("./components/changePassword/changePassword"));
const NewUser = React.lazy(() => import("./components/newUser/newUser"));
const EditUser = React.lazy(() => import("./components/editUser/editUser"));

const CategoryList = React.lazy(() => import("./components/category/categoryList/categoryList")); //Added by Lokesh
const CategoryAdd = React.lazy(() => import("./components/category/addCategory/addCategory")); //Added by Lokesh
const CategoryEdit = React.lazy(() => import("./components/category/editCategory/editCategory")); //Added by Lokesh

const FieldsList = React.lazy(() => import("./components/fields/fieldsList/fieldsList")); //Added by Lokesh
const FieldsAdd = React.lazy(() => import("./components/fields/addField/addField")); //Added by Lokesh
const FieldsEdit = React.lazy(() => import("./components/fields/editField/editField")); //Added by Lokesh

const SubCategoryList = React.lazy(() => import("./components/subCategory/subCategoryList/subCategoryList")); //Added by Lokesh
const SubCategoryAdd = React.lazy(() => import("./components/subCategory/AddSubCategory/AddSubCategory")); //Added by Lokesh
const SubCategoryEdit = React.lazy(() => import("./components/subCategory/editSubCategory/editSubCategory")); //Added by Lokesh





const ProductList = React.lazy(() => import("./components/productSection/productList/productList"));
const ProductAdd = React.lazy(() => import("./components/productSection/addProduct/addProduct"));
const ProductEdit = React.lazy(() => import("./components/productSection/editProduct/editProduct"));
const ProductView = React.lazy(() => import("./components/productSection/viewProduct/viewProduct"));

const BrandList = React.lazy(() => import("./components/brandSection/brandList/brandList"));
const BrandAdd = React.lazy(() => import("./components/brandSection/brandAdd/brandAdd"));
const BrandEdit = React.lazy(() => import("./components/brandSection/brandEdit/brandEdit"));

const SliderList = React.lazy(() => import("./components/sliderSection/sliderList/sliderList"));
const SliderAdd = React.lazy(() => import("./components/sliderSection/sliderAdd/sliderAdd"));
const SliderEdit = React.lazy(() => import("./components/sliderSection/sliderEdit/sliderEdit"));

const WeeklyDealsList = React.lazy(() => import("./components/weeklyDeals/weeklyDealsList/weeklyDealsList"));


const BasicSetting = React.lazy(() => import("./components/basicSettingSection/basicSettingList"));

const Pages = React.lazy(() => import("./components/CMSSection/Pages/Pages"));
const AddPage = React.lazy(() => import("./components/CMSSection/addPages/addPages"));
const EditPage = React.lazy(() => import("./components/CMSSection/editPages/editPages"));

const Blocks = React.lazy(() => import("./components/CMSSection/blocks/list"));
const AddBlock = React.lazy(() => import("./components/CMSSection/blocks/add"));
const EditBlock = React.lazy(() => import("./components/CMSSection/blocks/edit"));

const FaqCategories = React.lazy(() => import("./components/faqSection/faqCategories/faqCategoriesList/faqCategoriesList"));
const FaqCategoriesAdd = React.lazy(() => import("./components/faqSection/faqCategories/faqCategoriesAdd/faqCategoriesAdd"));
const FaqCategoriesEdit = React.lazy(() => import("./components/faqSection/faqCategories/faqCategoriesEdit/faqCategoriesEdit"));

const FaqSubcategories = React.lazy(() => import("./components/faqSection/faqSubcategories/faqSubcategoriesList/faqSubcategoriesList"));
const FaqSubcategoriesAdd = React.lazy(() => import("./components/faqSection/faqSubcategories/faqSubcategoriesAdd/faqSubcategoriesAdd"));
const FaqSubcategoriesEdit = React.lazy(() => import("./components/faqSection/faqSubcategories/faqSubcategoriesEdit/faqSubcategoriesEdit"));

const Faq = React.lazy(() => import("./components/faqSection/faq/faqList/faqList"));
const FaqAdd = React.lazy(() => import("./components/faqSection/faq/faqAdd/faqAdd"));
const FaqEdit = React.lazy(() => import("./components/faqSection/faq/faqEdit/faqEdit"));

const PlanList = React.lazy(() => import("./components/planSection/planList/planList"));
const PlanAdd = React.lazy(() => import("./components/planSection/planAdd/planAdd"));
const PlanEdit = React.lazy(() => import("./components/planSection/planEdit/planEdit"));

const FeatureList = React.lazy(() => import("./components/featureSection/featureList"));
const FeatureAdd = React.lazy(() => import("./components/featureSection/featureAdd"));
const FeatureEdit = React.lazy(() => import("./components/featureSection/featureEdit"));
const VideoStreamList = React.lazy(() => import("./components/videoStreamSection/videoStreamList"));
const VideoStreamAdd = React.lazy(() => import("./components/videoStreamSection/videoStreamAdd"));
const VideoStreamEdit = React.lazy(() => import("./components/videoStreamSection/videoStreamEdit"));
const NewsletterSubscriber = React.lazy(() => import("./components/newsLetterSubscribers/newsLetterSubscribersList/newsLetterSubscribersList"));
const Contact = React.lazy(() => import("./components/contactSection/contactList/contactList"));
const ConatctView = React.lazy(() => import("./components/contactSection/contactView/contactView"));
const PackageList = React.lazy(() => import("./components/packageSection/packageList"));
const PaymentGatewaysList = React.lazy(() => import("./components/paymentGateways/PaymentGatewaysList"));
const EmailTemplateList = React.lazy(() => import("./components/EmailTemplate/EmailTemplateList"));
const NoteList = React.lazy(() => import("./components/balanceActivateNote/noteList/NoteList"));
const BidIncrementsList = React.lazy(() => import("./components/bidIncrements/bidIncrementsList/BidIncrementsList"));
const ReasonList = React.lazy(() => import("./components/deactivateAccountReason/reasonList/reasonList"));
const LiveAuctionDurationList = React.lazy(() => import("./components/liveAuctionDuration/durationList/durationList"));
const CourierServicesList = React.lazy(() => import("./components/courierServices/courierServicesList/courierServicesList"));
const Parcel2GoDashboard = React.lazy(() => import("./components/parcel2goDashboard/Parcel2GoDashboard"));
const InvoiceManagement = React.lazy(() => import("./components/invoice/invoiceManagement/InvoiceManagement"));

const ReportAd = React.lazy(() => import("./components/reportAd/reportList/reportList"));
const TransactionsList = React.lazy(() => import("./components/transactions/transactionList/transactionList"));
const AdminTransactionHistory = React.lazy(() => import("./components/transactions/transactionHistory/transactionHistory"));
const ReportProductsList = React.lazy(() => import("./components/reportProducts/reportProductsList/reportProductsList"));
const PendingProductList = React.lazy(() => import("./components/productSection/productList/pendingProductList"));
const ExpiredProductList = React.lazy(() => import("./components/productSection/productList/expiredProductList"));
const PendingAccount = React.lazy(() => import("./components/userAccount/pendingAccounts"));
const SuspendedAccount = React.lazy(() => import("./components/userAccount/suspendedAccounts"));
const Logo = React.lazy(() => import("./components/logoSection/logo"));
const LearnCategoriesList = React.lazy(() => import("./components/learnSection/learnCategories/learnCategoriesList/learnCategoriesList"));
const LearnCategoriesAdd = React.lazy(() => import("./components/learnSection/learnCategories/learnCategoriesAdd/learnCategoriesAdd"));
const LearnCategoriesEdit = React.lazy(() => import("./components/learnSection/learnCategories/learnCategoriesEdit/learnCategoriesEdit"));
const LearnSubcategoriesList = React.lazy(() => import("./components/learnSection/learnSubcategories/learnSubcategoriesList/learnSubcategoriesList"));
const LearnSubcategoriesAdd = React.lazy(() => import("./components/learnSection/learnSubcategories/learnSubcategoriesAdd/learnSubcategoriesAdd"));
const LearnSubcategoriesEdit = React.lazy(() => import("./components/learnSection/learnSubcategories/learnSubcategoriesEdit/learnSubcategoriesEdit"));
const LearnList = React.lazy(() => import("./components/learnSection/learn/learnList/learnList"));
const LearnAdd = React.lazy(() => import("./components/learnSection/learn/learnAdd/learnAdd"));
const LearnEdit = React.lazy(() => import("./components/learnSection/learn/learnEdit/LearnEdit"));

const BoughtSoldProductList = React.lazy(() => import("./components/productSection/productList/boughtSoldProductList"));
const DisputeProducts = React.lazy(() => import("./components/productSection/productList/disputeProductList"));
const AdminChangePassword = React.lazy(() => import("./pages/adminChangePassword/adminChangePassword"));
const NotificationTestPage = React.lazy(() => import("./components/NotificationTest/NotificationTestPage"));
const TestOrderManager = React.lazy(() => import("./components/testManager/TestOrderManager"));
const App = () => {
  // useEffect(() => {
  //   document.body.classList.remove('fixedit_modal');
  // }, [])

  const handleClick = () => {
    document.body.classList.remove("fixedit_modal");
  };

  useEffect(() => {
    // Edit drawers (.editfix / fixedit_modal): Esc closes the same way as the overlay click.
    const handleEscape = (event) => {
      if (event.key !== "Escape") return;
      if (!document.body.classList.contains("fixedit_modal")) return;
      document.body.classList.remove("fixedit_modal");
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, []);

  useEffect(() => {
    // Cross-tab session sync. The native "storage" event only fires in
    // OTHER tabs when localStorage changes here, so this naturally ignores
    // the tab that actually performed the logout.
    const handleStorageChange = (event) => {
      // localStorage.clear() (used by header.js's logout) fires one event
      // with key === null rather than one event per removed key, so that
      // case has to be handled alongside the single-key "token" removal.
      const isTokenRemoved = event.key === "token" && !event.newValue && event.oldValue;
      const isFullClear = event.key === null;
      if (!isTokenRemoved && !isFullClear) {
        return;
      }
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    // <HttpsRedirect>
    <div className="App">
      <div onClick={handleClick} class="overForm"></div>
      <div class="main_board bg-gray" id="main_app1">
        <div
          style={{ flexWrap: "wrap", overflowX: "hidden" }}
          className="main_board_inner"
          id="main_app2"
        >
          <BrowserRouter>
            <Header />
            <Sidebar />
            <Suspense fallback={<div className="admin-route-loading">Loading…</div>}>
            <RequireAuth>
            <Switch>
              <Route exact path="/" component={Signup} />
              <Route exact path="/forgetPassword" component={ForgetPassword} />
              <Route
                exact
                path="/confirmPassword/:data"
                component={ConfirmPassword}
              />
              <Route exact path="/admin" component={Admin} />
              <Route exact path="/accounts" component={UserAccount} />
              <Route
                exact
                path="/pending-accounts"
                component={PendingAccount}
              />
              <Route
                exact
                path="/suspended-accounts"
                component={SuspendedAccount}
              />
              <Route
                exact
                path="/subscribed-users"
                component={SubscribedUser}
              />
              <Route
                exact
                path="/admin-change-password"
                component={AdminChangePassword}
              />
              <Route exact path="/newUser" component={NewUser} />
              <Route
                exact
                path="/change-password/:id"
                component={ChangePassword}
              />
              <Route exact path="/editUser/:id" component={EditUser} />
              <Route exact path="/category" component={LegacyAdminRedirect} />

              <Route exact path="/fields" component={FieldsList} />
              <Route exact path="/fields/add" component={FieldsAdd} />
              <Route exact path="/fields/edit/:id" component={FieldsEdit} />

              <Route exact path="/categories" component={CategoryList} />
              <Route exact path="/categories/add" component={CategoryAdd} />
              <Route
                exact
                path="/categories/edit/:id"
                component={CategoryEdit}
              />
              <Route exact path="/sub-categories" component={SubCategoryList} />
              <Route
                exact
                path="/sub-categories/add"
                component={SubCategoryAdd}
              />
              <Route
                exact
                path="/sub-categories/edit/:id"
                component={SubCategoryEdit}
              />
              <Route exact path="/addCategory" component={LegacyAdminRedirect} />
              <Route exact path="/editCategory/:id" component={LegacyAdminRedirect} />
              <Route
                exact
                path="/:category/AddSubCategory"
                component={LegacyAdminRedirect}
              />
              <Route
                exact
                path="/:category/:id/EditSubCategory"
                component={LegacyAdminRedirect}
              />
              <Route exact path="/:data/SubFirst" component={LegacyAdminRedirect} />

              <Route exact path="/ProductList" component={ProductList} />
              <Route
                exact
                path="/PendingProductList"
                component={PendingProductList}
              />
              <Route
                exact
                path="/ExpiredProductList"
                component={ExpiredProductList}
              />
              <Route exact path="/ProductAdd" component={ProductAdd} />
              <Route exact path="/ProductEdit/:id" component={ProductEdit} />
              <Route exact path="/product/view/:id" component={ProductView} />
              <Route exact path="/BrandList" component={BrandList} />
              <Route exact path="/BrandAdd" component={BrandAdd} />
              <Route exact path="/BrandEdit/:id" component={BrandEdit} />
              <Route exact path="/SliderList" component={SliderList} />
              <Route exact path="/SliderAdd" component={SliderAdd} />
              <Route exact path="/SliderEdit/:id" component={SliderEdit} />
              <Route
                exact
                path="/AddCategoryField"
                component={LegacyAdminRedirect}
              />
              <Route exact path="/basic-settings" component={BasicSetting} />
              <Route exact path="/Pages" component={Pages} />
              <Route exact path="/AddPage" component={AddPage} />
              <Route exact path="/EditPage/:id" component={EditPage} />
              <Route exact path="/Blocks" component={Blocks} />
              <Route exact path="/AddBlock" component={AddBlock} />
              <Route exact path="/EditBlock/:id" component={EditBlock} />
              <Route exact path="/faq-categories" component={FaqCategories} />
              <Route
                exact
                path="/faq-addcategories"
                component={FaqCategoriesAdd}
              />
              <Route
                exact
                path="/faq-editcategories/:id"
                component={FaqCategoriesEdit}
              />
              <Route
                exact
                path="/faq-subcategories"
                component={FaqSubcategories}
              />
              <Route
                exact
                path="/faq-addsubcategories"
                component={FaqSubcategoriesAdd}
              />
              <Route
                exact
                path="/faq-editsubcategories/:id"
                component={FaqSubcategoriesEdit}
              />
              <Route exact path="/faq" component={Faq} />
              <Route exact path="/faq-add" component={FaqAdd} />
              <Route exact path="/faq-edit/:id" component={FaqEdit} />

              <Route
                exact
                path="/learn-categories"
                component={LearnCategoriesList}
              />
              <Route
                exact
                path="/learn-addcategories"
                component={LearnCategoriesAdd}
              />
              <Route
                exact
                path="/learn-editcategories/:id"
                component={LearnCategoriesEdit}
              />
              <Route
                exact
                path="/learn-subcategories"
                component={LearnSubcategoriesList}
              />
              <Route
                exact
                path="/learn-addsubcategories"
                component={LearnSubcategoriesAdd}
              />
              <Route
                exact
                path="/learn-editsubcategories/:id"
                component={LearnSubcategoriesEdit}
              />
              <Route exact path="/learn" component={LearnList} />
              <Route exact path="/learn-add" component={LearnAdd} />
              <Route exact path="/learn-edit/:id" component={LearnEdit} />
              <Route exact path='/logo' component={Logo} />
              <Route exact path="/listing-plans" component={PlanList} />
              <Route exact path="/plan-add" component={PlanAdd} />
              <Route exact path="/plan-edit/:id" component={PlanEdit} />

              <Route exact path="/listing-features" component={FeatureList} />
              <Route exact path="/features-add" component={FeatureAdd} />
              <Route exact path="/features-edit/:id" component={FeatureEdit} />

              <Route exact path="/listing-video-stream" component={VideoStreamList} />
              <Route exact path="/features-video-stream-add" component={VideoStreamAdd} />
              <Route exact path="/features-video-stream-edit/:id" component={VideoStreamEdit} />

              <Route
                exact
                path="/news-letter-subscribers"
                component={NewsletterSubscriber}
              />
              <Route exact path="/contact-us" component={Contact} />
              <Route exact path="/contact-view/:id" component={ConatctView} />
              <Route exact path="/listing-packages" component={PackageList} />
              <Route
                exact
                path="/payment-gateways"
                component={PaymentGatewaysList}
              />
              <Route
                exact
                path="/email-templates"
                component={EmailTemplateList}
              />
              <Route
                exact
                path="/balanceActiveNotes"
                component={NoteList}
              />
              <Route
                exact
                path="/bidIncrements"
                component={BidIncrementsList}
              />
              <Route
                exact
                path="/DeactivateReasonList"
                component={ReasonList}
              />
              <Route exact path="/ReportAd" component={ReportAd} />
              <Route exact path="/Transactions" component={TransactionsList} />
              <Route exact path="/TransactionHistory" component={AdminTransactionHistory} />
              <Route
                exact
                path="/ReportProductList"
                component={ReportProductsList}
              />
              <Route
                exact
                path="/LiveAuctionDuration"
                component={LiveAuctionDurationList}
              />
              <Route
                exact
                path="/CourierServices"
                component={CourierServicesList}
              />
              <Route
                exact
                path="/ShippingDashboard"
                component={Parcel2GoDashboard}
              />
              <Route
                exact
                path="/Parcel2GoDashboard"
                component={Parcel2GoDashboard}
              />
              <Route
                exact
                path="/InvoiceManagement"
                component={InvoiceManagement}
              />

              <Route
                exact
                path="/BoughtSoldProductList"
                component={BoughtSoldProductList}
              />
              <Route
                exact
                path="/DisputeProductList"
                component={DisputeProducts}
              />

              <Route exact path="/notification-test" component={NotificationTestPage} />
              <Route exact path="/admin/order-test-tool" component={TestOrderManager} />

              <Route exact path="/WeeklyDeals" component={WeeklyDealsList} />
              {/* <Route exact path="/WeeklyDealsAdd" component={WeeklyDealsAdd} />
              <Route exact path="/WeeklyDealsEdit/:id" component={WeeklyDealsEdit} /> */}
              <Redirect to="/" />
            </Switch>
            </RequireAuth>
            </Suspense>
            <Footer />
          </BrowserRouter>
        </div>
      </div>
    </div>
    //  </HttpsRedirect>
  );
};

export default App;
